import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ConfigDataProvider } from '../../providers/config-data/config-data';

@Component({
	selector: 'message-item',
	templateUrl: 'message-item.html'
})
export class MessageItemComponent implements OnInit {

	@Input('item') messageItem: any;
	@Output('onClick') onClick: EventEmitter<any> = new EventEmitter();
	@Output('onDelete') onDelete: EventEmitter<any> = new EventEmitter();

	private currentuser = null;
	private itemEle: HTMLElement;

	constructor(
		private configDataProvider: ConfigDataProvider
	) {
		this.currentuser = this.configDataProvider.getUserData();
	}

	ngOnInit() {
		this.setClassInMessageItem();
	}

	setClassInMessageItem() {

		setTimeout(() => {

			this.itemEle = document.getElementById(this.messageItem.id);
			var classArray = this.messageItem.classname.split(" ");
			if (classArray && classArray.length > 0) {
				classArray.forEach(element => {
					this.itemEle.classList.add(element);
				});
			}

		}, 100)

	}

}



// WEBPACK FOOTER //
// ./src/components/message-item/message-item.ts